import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalReportAccount  {
    _originalTypeClassName = "zERP.BO.GeneralJournalReportAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalReportAccount.translate = translateService;
}
this.Id = null;
this.Code = null;
this.AccountName = null;
this.Description = null;
this.Date = null;
this.Debit = null;
this.Credit = null;
this.GroupBy = null;
this.TransactionNumber = null;
this.GeneralJournalReportAccountKey = null;
this._key = this.GeneralJournalReportAccountKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Code:any;
AccountName:any;
Description:any;
Date:any;
Debit:any;
Credit:any;
GroupBy:any;
TransactionNumber:any;
private _GeneralJournalReportAccountKey:any;
get GeneralJournalReportAccountKey(): any {
    return this._GeneralJournalReportAccountKey;
  }
set GeneralJournalReportAccountKey(value: any) {
    this._GeneralJournalReportAccountKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalReportAccountKey == null || $this.GeneralJournalReportAccountKey == 0;
            }


}